var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itm.onNavBar)?_c('v-list-item',{attrs:{"to":{name: _vm.itm.name}}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.itm.title))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }